import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import api from 'API';
import { clearUserToken } from './userTokenSlice';
import { withNotificationForError } from './helper';

export const fetchAllPersonalData = createAsyncThunk(
  'personal/fetchAllPersonalData',
  withNotificationForError(async (payload, { getState }) => {
    const userType = getState().userToken.tokenType;

    const response = await axios(api.users.profile.personal(userType).AXIOS('get'));

    return response.data.data;
  })
);

const initialState = {
  loading: false,
  data: {},
  activeBusinessProfileId: '',
  error: null,
  switchCustomerId: true,
  showBusinessProfilesModal: true,
  preRegistrationId: false,
  reloadPersonalData: false,
  email: null,
  customers_ids: [],
  doubleAccountMagmaMonesto: false,
  rubTransferEnabled: false,
};

const personalSlice = createSlice({
  name: 'personal',
  initialState: initialState,
  reducers: {
    getPersonalData(state, action) {
      state.data = action.payload;
    },
    switchActiveBusinessProfile(state, action) {
      state.activeBusinessProfileId = action.payload.id;
      state.switchCustomerId = action.payload.isNew ?? true;
    },
    closeShowBusinessProfilesModal(state) {
      state.showBusinessProfilesModal = false;
    },
    clearPersonal() {
      return initialState;
    },
    setPreRegistrationId(state, action) {
      state.preRegistrationId = action.payload.preRegistrationId;
    },
    reloadPersonalData(state, action) {
      state.reloadPersonalData = action.payload?.reload ?? true;
    },
    changePersonalDataField(state, action) {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    setUserEmail(state, action) {
      state.email = action.payload;
    },
    setUserDoubleAccountMagmaMonesto(state, action) {
      state.doubleAccountMagmaMonesto = action.payload;
    },
    setRubTransferEnabled(state, action) {
      state.rubTransferEnabled = action.payload;
    },
    setCustomersIds(state, action) {
      state.customers_ids = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPersonalData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllPersonalData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = action.payload;
        state.preRegistrationId =
          (!action.payload.reg_status && action.payload.financial_institution_customer_id) ?? false;
        if (!state.reloadPersonalData) {
          if (state.switchCustomerId) {
            const businessProfileWithOriginId = action.payload.business_profiles.find(
              (profile) => profile._id === action.payload.business_profile_id
            );

            state.activeBusinessProfileId = businessProfileWithOriginId
              ? businessProfileWithOriginId.customer_id
              : action.payload.customer_id;
          } else {
            state.switchCustomerId = true;
          }
        }
      })
      .addCase(fetchAllPersonalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      })
      .addCase(clearUserToken, () => {
        return initialState;
      });
  },
});

export const {
  changePersonalDataField,
  switchActiveBusinessProfile,
  closeShowBusinessProfilesModal,
  setPreRegistrationId,
  reloadPersonalData,
  setUserEmail,
  setUserDoubleAccountMagmaMonesto,
  setRubTransferEnabled,
  setCustomersIds,
} = personalSlice.actions;
export default personalSlice.reducer;
